import React from "react";
import { AlertTriangle, Trash2 } from "lucide-react";

const DeleteConfirmDialog = ({ open, title, message, onConfirm, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black/30 backdrop-blur-[2px]" />
      <div className="relative flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white dark:bg-neutral-900 rounded-2xl shadow-2xl w-full max-w-md mx-auto overflow-hidden">
          <div className="px-6 pt-6 pb-4 text-center">
            <div className="mx-auto w-12 h-12 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center mb-4">
              <AlertTriangle size={24} className="text-red-600 dark:text-red-500" />
            </div>
            <h2 className="text-base font-semibold text-neutral-900 dark:text-white mb-2">{title}</h2>
            <p className="text-neutral-600 dark:text-neutral-400">{message}</p>
          </div>
          <div className="flex justify-end space-x-3 px-6 py-4 border-t border-neutral-200 dark:border-neutral-800">
            <button
              type="button"
              className="px-4 py-2 text-sm text-neutral-700 dark:text-neutral-300 bg-slate-300 dark:bg-neutral-700 hover:bg-slate-400 dark:hover:bg-neutral-600 rounded-xl font-medium transition-all"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="px-4 py-2 text-sm bg-red-600 hover:bg-red-700 text-white rounded-xl font-medium transition-all flex items-center shadow-sm"
              onClick={onConfirm}
            >
              <Trash2 size={16} className="mr-2" />
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmDialog;
